export default {
	loadDefaultProviders: ['local', 'local2', 'thunderwaveServer'],
	loadDefaultPlugins: ['defaultPack']
};
